<!-- track order status -->
<div *ngIf="isOrderTrackStatusView">
    <div class="modal-header customBlueHeader">
        <p class="modal-title">Order Tracking Status</p>

        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body customModalBody">


        <table class="table table-striped table-hover table-responsive customTable">
            <thead>
                <tr>
                    <th>Order</th>
                    <th>User Name</th>
                    <th>User ID</th>
                    <th>Role</th>
                    <th>Action</th>
                    <th>Order Status</th>
                     <th>Updated On</th> 
                    <th>Text</th>

                </tr>


            <tbody>


                <tr *ngFor="let data of orderLogData ">
                    <td>{{data.wodid}}</td>
                    <td>{{data.actionByName}}</td>
                    <td>{{data.actionById}}</td>
                    <td>{{data.role}}</td>
                    <td>{{data.action}}</td>
                    <td>{{data.status_name}}</td>
                   <td>{{data.created_date | date:'dd/MM/yyyy hh:mm a'}}</td>
                    <td>{{data.reason}}</td>

                </tr>
            </tbody>
        </table>

    </div>
</div>

<!-- show receipts -->
<div *ngIf="isReceiptBillView">
    <div class="modal-header customBlueHeader">
        <p class="modal-title">Refund Receipt Details</p>

        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body customModalBody">


        <table class="table table-striped table-hover table-responsive customTable">
            <thead>
                <tr>
                    <th>Order ID</th>
                    <th>Receipt ID</th>
                    <th>Receipt Amount</th>
                    <th>Receipt Date</th>
                    <th>Payment Mode</th>
                    <th>Payment RefNo</th>
                    <th>Submitted Date</th>
                </tr>
            <tbody>
                <tr *ngFor="let data of receiptLogData ">
                    <td>{{order_id}}</td>
                    <td>{{data.receipt_id}}</td>
                    <td>{{data.receipt_amount}}</td>
                    <td>{{data.receipt_date | date:'dd/MM/yyyy hh:mm a'}}</td>
                    <td>
                        <span *ngIf="data.payment_mode == 17">RazorPay</span>
                        <span *ngIf="data.payment_mode == 4">COD</span>
                    </td>
                    <td>{{data.payment_ref_no}}</td>
                   <td>{{data.submited_date}}</td>
                </tr>
            </tbody>
        </table>

    </div>
</div>

<!-- processing refund order -->
<div *ngIf="isProcessRefundOrderView">
    <div class="modal-header customBlueHeader">
        <p class="modal-title">Process Refund Order</p>

        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body customModalBody">

    <form [formGroup]="processForm">
        <table class="table table-striped table-hover table-bordered">
            <thead>
                <tr>
                    <th>Payment Type</th>
                    <th>Amount</th>
                    <th *ngIf="!isInstantRefundEnable">Transaction Code</th>
                    <th *ngIf="isInstantRefundEnable">Remarks</th>
                </tr>
            <tbody>
                <tr>
                    <td *ngIf="isInstantRefundEnable">
                        <select formControlName="paymentType" style="height:28px;">
                        <option value="instantrefund">Instant Refund</option>
                        </select>
                    </td>
                    <td *ngIf="!isInstantRefundEnable">
                        <select  style="height:28px;" formControlName="paymentType">
                        <option value="null">Select type</option>
                        <option value="creditcard">Credit Card</option>
                        <option value="debitcard">Debit Card</option>
                        <option value="netbanking">Net Banking</option>
                        </select>
                    </td>
                    <td>
                        <input type="text"  formControlName="refundAmount" >
                    </td>
                    <td *ngIf="!isInstantRefundEnable">
                        <input type="text" formControlName="transcactionCode">
                    </td>
                    <td *ngIf="isInstantRefundEnable">
                         <textarea class="form-control col-form-label-sm " rows="3" formControlName="transcactionCode"></textarea>
                    </td>
                </tr>
            </tbody>
        </table>
            <div class="modal-footer customModalFooter customModalFooter">
            <button  class="btn closeGreenBordBtn" (click)="close()" >Cancel</button>
            <button type="submit" class="btn info_btn" (click)="process_refund_order()">Submit</button>
          </div>
    </form>
    </div>
</div>

<!-- refund reject -->
<div *ngIf="isRefundRejectedView">
<div class="modal-header customBlueHeader">
  <p class="modal-title">Are you sure you want to reject this order???</p>
  
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body customModalBody">
    
    <form [formGroup]="RejectForm">


        <div class="form-group">
            <label>Select Reason Type</label>
            <select class="form-control col-form-label-sm" formControlName="sub_category">
                <option [ngValue]="null" disabled>Please select reason to reject </option>
                <option value="The Payment failed amount will be refunded automatically">The Payment failed amount will be refunded automatically</option>
                <option value="Incorret claim/wrong amount">Incorret claim/wrong amount</option>
                <option value="Others">Others</option>
            </select>
          </div>


        <div class="form-group">
            <label>Reason</label>
            <textarea class="form-control col-form-label-sm" formControlName="sub_category_description"></textarea>
          </div> 
      
          <div class="modal-footer customModalFooter customModalFooter">
            <button  class="btn closeGreenBordBtn" (click)="close()" >Cancel</button>
            <button type="submit" class="btn green_btn" (click)="refund_reject()">Submit</button>
          </div>
        </form>

</div>
</div>
